import { useQuery } from '@tanstack/react-query';
import {
  UserKeys,
  doApiCheck,
  getDirectoryGroupQuery,
} from '../../../../api/users-api';
import { useLocation, useParams } from 'react-router-dom';
import { userPortalPagesConfig } from '../../../../shared/user-portal-pages-config';

import GroupCIMembershipGrid from './group-ci-membership-grid';
import GroupMembershipGrid from './group-membership-grid';
import GroupMembershipUserPortalGrid from './group-membership-user-portal-grid';

import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

export default function GroupMembership() {
  const { groupEmail } = useParams() as { groupEmail: string };

  const location = useLocation();
  const userView = location.pathname.includes(
    userPortalPagesConfig.userPortal.link
  );
  const { data: group } = useQuery(
    getDirectoryGroupQuery(groupEmail, userView)
  );

  const { data: accessGranted, isLoading: isAccessGrantedLoading } = useQuery({
    queryKey: [UserKeys.AdminApiSettings, 'cloudIdentity'],
    queryFn: () => doApiCheck('cloudIdentity', null),
    enabled: !userView,
  });

  if (!group || isAccessGrantedLoading) {
    return (
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{ width: '100%', minHeight: 300 }}
      >
        <CircularProgress />
      </Stack>
    );
  }
  return userView ? (
    <GroupMembershipUserPortalGrid group={group} />
  ) : accessGranted && !userView ? (
    <GroupCIMembershipGrid group={group} />
  ) : (
    <GroupMembershipGrid group={group} />
  );
}
